var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isshow)?_c('div',{staticClass:"radishdetail",staticStyle:{"width":"400px"}},[_c('div',{staticClass:"close",on:{"click":function($event){_vm.isshow = false}}},[_vm._v("X")]),_c('radishScoreInner',{ref:"radishScoreInner"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }